import { cn } from '@Utils/cn';
import { FlowContextHeader } from '../FlowContextHeader';
import { FlowHeader } from '../FlowHeader';
import { FlowStageProgressBar } from '../FlowStageProgressBar';
import type { FlowStageInfo, FlowStageStatus, FlowViewMode } from '../types';

export interface FlowContextPaneProps {
  flowTitle: string;
  startTime: string;
  stages: FlowStageInfo[];
  activeStageId: string | null;
  stageTitle: string;
  stageStatus: FlowStageStatus;
  activeView: FlowViewMode;
  onClose?: () => void;
  onStageSelect?: (stageId: string) => void;
  onStageNavigate?: (direction: 'prev' | 'next') => void;
  disablePrev?: boolean;
  disableNext?: boolean;
  onViewChange: (view: FlowViewMode) => void;
  className?: string;
}

export function FlowContextPane({
  flowTitle,
  startTime,
  stages,
  activeStageId,
  stageTitle,
  stageStatus,
  activeView,
  onClose,
  onStageSelect,
  onStageNavigate,
  disablePrev,
  disableNext,
  onViewChange,
  className,
}: FlowContextPaneProps) {
  return (
    <div
      className={
        className ??
        'dark flex w-full shrink-0 flex-col overflow-hidden border-b border-zinc-700 bg-zinc-800'
      }
    >
      <FlowHeader
        flowTitle={flowTitle}
        startTime={startTime}
        onClose={onClose}
      />
      <FlowContextHeader
        stageTitle={stageTitle}
        stageStatus={stageStatus}
        activeView={activeView}
        onViewChange={onViewChange}
        className="flex w-full shrink-0 items-center justify-between p-4"
      />
      <div
        className={cn(
          'w-full overflow-hidden transition-[max-height] duration-300 ease-in-out',
          activeView === 'flow' ? 'max-h-24' : 'max-h-0',
        )}
      >
        <FlowStageProgressBar
          stages={stages}
          activeStageId={activeStageId}
          onStageSelect={onStageSelect}
          onPrev={onStageNavigate ? () => onStageNavigate('prev') : undefined}
          onNext={onStageNavigate ? () => onStageNavigate('next') : undefined}
          disablePrev={disablePrev}
          disableNext={disableNext}
        />
      </div>
    </div>
  );
}
